import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeExternalId: (value: string) => void;
}

export const ExternalIdField: React.FC<IProps> = React.memo(({ changeExternalId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterExternalId') }], [t]);

	return (
		<FormInput
			testId="ExternalIdField"
			name="externalId"
			label="externalIdLabel"
			onChange={changeExternalId}
			validationRules={validationRules}
		/>
	);
});
